export default {"src":"/_next/static/media/circle-p.f86544f7.svg","height":505,"width":506,"blurWidth":0,"blurHeight":0};